/**
 * Formats a phone number with dashes as the user types
 * Only allows numbers and automatically inserts dashes in the format: XXX-XXX-XXXX
 */
export function formatPhoneNumber(value: string): string {
	// Remove all non-digit characters
	const numbersOnly = value.replace(/\D/g, '');

	// Limit to 10 digits
	const limitedNumbers = numbersOnly.slice(0, 10);

	// Apply formatting based on length
	if (limitedNumbers.length <= 3) {
		return limitedNumbers;
	} else if (limitedNumbers.length <= 6) {
		return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3)}`;
	} else {
		return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3, 6)}-${limitedNumbers.slice(6)}`;
	}
}

/**
 * Removes all non-digit characters from a phone number
 * Used to clean the phone number before sending it in a request
 */
export function cleanPhoneNumber(value: string): string {
	return value.replace(/\D/g, '');
}

/**
 * Validates if a phone number has exactly 10 digits
 */
export function isValidPhoneNumber(value: string): boolean {
	const cleaned = cleanPhoneNumber(value);
	return cleaned.length === 10;
}
